import _ from 'lodash';
import axios from 'axios';

window._ = _;
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.$ = window.jQuery = require('jquery');

window.Popper = require('@popperjs/core');
window.bootstrap = require('bootstrap');

require('magnific-popup');

class BomOrganum {
    constructor() {
        this.lgToken = {};
        this.initLg();
        this.initGalleries();
    }

    initLg() {
        if ($('html[lang]').attr('lang') !== 'de') {
            this.lgToken['loadingImagesFromServer'] = 'loading';
            this.lgToken['nextImage'] = 'Next image';
            this.lgToken['previewImage'] = 'Previous image';
            this.lgToken['imageNoOfCount'] = '%curr% / %total%';
            this.lgToken['canNotLoadImage'] = 'Can not load this image!';
        } else {
            this.lgToken['loadingImagesFromServer'] = 'Lade Bilder vom Server.';
            this.lgToken['nextImage'] = 'Nächstes Bild';
            this.lgToken['previewImage'] = 'Vorheriges Bild';
            this.lgToken['imageNoOfCount'] = '%curr% von %total%';
            this.lgToken['canNotLoadImage'] = 'Das Bild konnte nicht geladen werden.';
        }
    }

    initGalleries() {
        let that = this;
        $('.gallerie').each(function () {
            $(this).find('a[href]').magnificPopup({
                type: 'image',
                tLoading: that.lgToken['loadingImagesFromServer'],
                gallery: {
                    tNext: that.lgToken['nextImage'],
                    tPrev: that.lgToken['previewImage'],
                    navigateByImgClick: true,
                    enabled: true,
                    tCounter: that.lgToken['imageNoOfCount'],
                    preload: [1, 2]
                },
                image: {
                    tError: that.lgToken['canNotLoadImage']
                }
            });
        });
    }
}

new BomOrganum();
